module.exports = __webpack_public_path__ + "media/images/icons/edit_green-2a6712383de9aaf5954c07b020e04054.svg";